import script from "./TreeNodeItem.vue?vue&type=script&setup=true&lang=js"
export * from "./TreeNodeItem.vue?vue&type=script&setup=true&lang=js"

import "./TreeNodeItem.vue?vue&type=style&index=0&id=2ffa36a6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ffa36a6"]])

export default __exports__